<template>
	<window-view title="Aktivitet" v-on="$listeners" :width="800" :actions="_actions">
		<panel-view>
			<panel-sep-view>
				<grid-view>
					<prism-editor class="my-editor" v-model="m.payload" :highlight="highlighter" line-numbers style="height: 600px;"></prism-editor>
				</grid-view>
				<grid-view>
					<div>{{ _timestamp }}</div>
				</grid-view>
			</panel-sep-view>
		</panel-view>
	</window-view>
</template>

<script>
	import activity from '../../../model/activity';

	

	import { highlight, languages } from 'prismjs/components/prism-core';
	import 'prismjs/components/prism-json';
	//import 'prismjs/themes/prism-tomorrow.css';
	import 'prism-themes/themes/prism-ghcolors.css';

	export default {
		props: ['model', 'submit'],
		data() {
			return {
				m: activity.model()
			};
		},
		computed: {
			_timestamp() {
				try {
					const json = JSON.parse(this.m.payload);
					return json.hasOwnProperty('timestamp') ? this.$options.filters.unix_timestamp_s(json.timestamp) : '';
				} catch (e) {
					return '';
				}
			},
			_actions() {
				//const self = this;

				return [
					{
						label: 		'Luk',
						emphasis: 	'text',
						action:		() => true
					}
				];
			}
		},
		methods: {
			highlighter(code) {
				return highlight(code, languages.json); //returns html
			}
		},
		mounted() {
			try {
				const json = JSON.parse(this.m.payload);
				this.m.payload = JSON.stringify(json, null, 4);
			} catch (e) {
				//
			}
		},
		async created() {
			console.log('languages', languages);
			console.log('m', this.model);
			this.m = {...this.m, ...this.model};
		}
	}
</script>

<style lang="scss" scoped>
	/* required class */
	.my-editor {

		background: #f5f5f5;
		color: #ccc;

		font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
		font-size: 14px;
		line-height: 1.5;
		padding: 5px;
	}

	/* optional class for removing the outline */
	.prism-editor__textarea:focus {
		outline: none;
	}
</style>